import { Outlet } from 'react-router';
import Stack from '@mui/material/Stack';
import { type StackProps, useTheme } from '@mui/material';
import { getStackSx } from './styles.ts';

export const MainLayout = ({ sx, children, ...rest }: StackProps) => {
  const theme = useTheme();
  return (
    <Stack sx={getStackSx(theme, sx)} {...rest}>
      {children}
      <Outlet />
    </Stack>
  );
};
